import type { SMSNotification } from '@packages/domain/models/smsNotification';
import { schemas } from 'constants/schemas';
import type { SMSNotificationResponse } from 'services/payex/payments/types';
import { normalizeResponse } from 'utils/normalize/normalize';

export const normalizeSmsNotifications = (
  smsNotification: SMSNotificationResponse,
): {
  entities: {
    smsNotification: Record<string, SMSNotification>;
  };
  result: string[];
} => normalizeResponse(smsNotification, schemas.smsNotification);
